<!-- Thêm mới chứng thư số -->
<div [ngClass] = "isCreateMysign ? 'widthSign' : ''">
  <h2 mat-dialog-title mat-dialog-draggable-title> {{'digital_certificate_management.ttl_add' | translate}}
    <button type="button" class="close" aria-label="Close" (click)="onNoClick()">
      <span aria-hidden="true">&times;</span>
    </button>
  </h2>

  <mat-divider></mat-divider>


  <form name="form" #f="ngForm" autocomplete="off"
        (ngSubmit)="f.form.valid && errorStatus == null && codeError == null && !maxSizeInput && add()"
        [appCheckPhone]="['phoneNumber']" appFocusFirstElement>
    <mat-dialog-content>
      <div class="row mt-3">
        <!-- Doanh nghiệp -->
        <div class="col-12 mb-3">
          <small>{{'digital_certificate_management.lbl_enterprise' | translate}}</small>
          <p class="dotted-5">{{enterpriseName}}</p>
        </div>

        <!-- Loại chứng thư số -->
        <div class="col-12 mb-3">
          <!-- Radio-button -->
          <span style="margin-bottom: 0.5em; font-family: inherit; display: inline-block; color: rgba(0, 0, 0, 0.65);">
          {{'digital_certificate_management.cbx_certificate_type.lbl_certificate_type' | translate}}
        </span><br/>
          <mat-radio-group #typeCertificateSelect (focusout)="(checkFocus = true)"
                           (focus)="commonService.openComboBox(checkFocus, typeCertificateSelect)" id="typeCertificate"
                           [(ngModel)]="digitalCertificate.typeCertificate"
                           (change)="checkFocus = false; onChangeSelectCertificateType($event.value);"
                           name="typeCertificate"
                           #typeCertificate="ngModel" [ngClass]="{ 'is-invalid': f.submitted && typeCertificate.invalid }"
                           required
                           maxlength="100">
            <mat-radio-button *ngIf="checkMoha != true && !checkUserType" [value]="2" class="pr-5" >
              {{'digital_certificate_management.cbx_certificate_type.cbx_sim_ca' | translate}}
            </mat-radio-button>
            <mat-radio-button *ngIf="!checkUserType" [value]="1" class="pr-5">
              {{'digital_certificate_management.cbx_certificate_type.cbx_usb' | translate}}
            </mat-radio-button>
            <mat-radio-button *ngIf="isHsmPermission && !isDigital && !checkUserType" [value]="0" class="pr-5">
              {{'digital_certificate_management.cbx_certificate_type.cbx_server' | translate}}
            </mat-radio-button>
            <mat-radio-button [value]="certificateType.CLOUD_CA" class="pr-5">
              {{'digital_certificate_management.cbx_certificate_type.cbx_cloud_ca' | translate}}
            </mat-radio-button>
            <mat-radio-button [value]="3" *ngIf="!isDigital && !checkUserType && userType == 5 && !isSignDigitalCert" class="pr-5">
              {{'digital_certificate_management.cbx_certificate_type.cbx_otp' | translate}}
            </mat-radio-button>
            <mat-radio-button *ngIf="isEasyCAPermission && !isDigital && !checkUserType" [value]="certificateType.EASY_CA" class="pr-5">
              {{'digital_certificate_management.cbx_certificate_type.cbx_easy_ca' | translate}}
            </mat-radio-button>
            <mat-radio-button *ngIf="entType == '1' && !checkUserType && isVNeIDPermission && userType == 5" [value]="certificateType.VNEID" class="pr-5">
              {{'digital_certificate_management.cbx_certificate_type.cbx_vneid' | translate}}
            </mat-radio-button>
            <!-- Tạm ẩn chức năng thêm chứng thư số HSM -->
            <!-- <mat-radio-button [value]="4" class="pr-5">
              {{'digital_certificate_management.cbx_certificate_type.cbx_hsm' | translate}}
            </mat-radio-button> -->
          </mat-radio-group>
          <mat-error *ngIf="f.submitted || typeCertificate.invalid">
          <span class="text-error" *ngIf="typeCertificate?.errors?.required">
            {{'validation.lbl_validation_certificate_required' | translate}}
          </span>
          </mat-error>

          <!-- show cảnh báo khi có tạo trùng một trong các Chứng thư số -->
          <mat-error *ngIf="codeError != null">
          <span class="text-error" *ngIf="codeError == 0">
            {{'validation.certificate_status_hsm_pending' | translate}}
          </span>
            <span class="text-error" *ngIf="codeError == 1">
            {{'validation.certificate_status_hsm_active' | translate}}
          </span>
            <span class="text-error" *ngIf="codeError == 2">
            {{'validation.certificate_status_signuater_server_pending' | translate}}
          </span>
            <span class="text-error" *ngIf="codeError == 3">
            {{'validation.certificate_status_signuater_server_active' | translate}}
          </span>
            <span class="text-error" *ngIf="codeError == 4">
            {{'validation.certificate_status_signuater_server_pending_hsm' | translate}}
          </span>
            <span class="text-error" *ngIf="codeError == 5">
            {{'validation.certificate_status_hsm_pending_signatureserver' | translate}}
          </span>
          </mat-error>
        </div>


        <!-- *********_SimCA_********* -->
        <!-- số điện thoại -->
        <ng-container *ngIf="(digitalCertificate.typeCertificate == 2 || digitalCertificate.typeCertificate == 3) && checkMoha != true">
          <div class="col-lg-4 col-sm-6 mt-3"
          >
            <mat-form-field class="w-100" style="padding-bottom: 2px">
                <span matPrefix>+84 &nbsp;</span>
                <input (focusout)="outPhoneNumberInput()" matInput type="text"
                      placeholder="{{'digital_certificate_management.lbl_phone' | translate}}"
                      [(ngModel)]="digitalCertificate.phoneNumber" name="phone" #phone="ngModel"
                      [ngClass]="{ 'is-invalid': f.submitted && phone.invalid }" [maxlength]="maxLengthPhone" required
                      [pattern]="phonePattern2"
                      >
                <button mat-button *ngIf="digitalCertificate.phoneNumber" type="button" matSuffix mat-icon-button
                        aria-label="Clear" (click)="digitalCertificate.phoneNumber=''">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="f.submitted || phone.invalid">
                <span class="text-error" *ngIf="phone?.errors?.required">
                  {{'validation.phone_number_re' | translate}}
                </span>
                  <span class="text-error" *ngIf="phone?.errors?.pattern">
                  {{'validation.phone_format_upgrade' | translate}}
                </span>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg-8 col-sm-6 d-flex justify-content-start align-items-center"
                *ngIf="digitalCertificate.typeCertificate == 2">
              <button mat-raised-button type="button"
                      [disabled]="!digitalCertificate.phoneNumber || !digitalCertificate.enterpriseId || phone.hasError('pattern')"
                      (click)="getCertificateOfSimCA()" color="primary">
                <mat-icon class="mr-0">list</mat-icon>
                {{'button.get_list' | translate}}
              </button>
            </div>
        </ng-container>


        <!-- danh sách CTS-->
        <div class="col-12 pr-075" *ngIf="digitalCertificate.typeCertificate == 2 && checkMoha != true">
          <ng-container *ngIf="dataSource == undefined; else getListSuccess"></ng-container>
          <ng-template #getListSuccess>
            <!-- Start table -->
            <mat-table [dataSource]="dataSource" class="mt-3">
              <!-- check -->
              <ng-container matColumnDef="check">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center check-col">
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mat-header-cell-center check-col"
                          (click)="$event.stopPropagation()">
                  <mat-checkbox [disabled]="element.isUsed" color="primary"
                                (change)="clickCertificateSimCA(element.serialNumber, element.checked)"
                                [ngModelOptions]="{standalone: true}" [(ngModel)]="element.checked"></mat-checkbox>
                </mat-cell>
              </ng-container>

              <!-- Số thứ tự -->
              <ng-container matColumnDef="stt">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center no-col">
                  {{'enterprise_contract.table_headers.No' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mat-header-cell-center no-col">
                  {{element.STT}}
                </mat-cell>
              </ng-container>

              <!-- Tên chứng thư -->
              <ng-container matColumnDef="certificateName">
                <mat-header-cell *matHeaderCellDef class="text-center">
                  {{'enterprise-certificate_management.table_headers.cer_name' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" [matTooltip]="element.certificateName" class="text-center">
                  <span class="fix-width text-left">{{element.certificateName}}</span>
                </mat-cell>
              </ng-container>

              <!-- serialNumber -->
              <ng-container matColumnDef="serialNumber">
                <mat-header-cell *matHeaderCellDef class="text-center">
                  {{'enterprise-certificate_management.table_headers.serial_number' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" [matTooltip]="element.serialNumber" class="text-center">
                  <span class="fix-width">{{element.serialNumber}}</span>
                </mat-cell>
              </ng-container>

              <!-- Mã số thuế -->
              <ng-container matColumnDef="taxCode">
                <mat-header-cell *matHeaderCellDef class="text-center">
                  {{'headertable.tax_code_no' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="text-center">
                  {{element.taxCode}}
                </mat-cell>
              </ng-container>

              <!-- Ngày hiệu lực -->
              <ng-container matColumnDef="activeDate">
                <mat-header-cell *matHeaderCellDef class="text-center">
                  {{'enterprise-certificate_management.table_headers.effective_date' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="number-cell-right">
                  {{element.activeDate | dateformat}}
                </mat-cell>
              </ng-container>

              <!-- Ngày hết hạn -->
              <ng-container matColumnDef="expireDate">
                <mat-header-cell *matHeaderCellDef class="text-center">
                  {{'enterprise-certificate_management.table_headers.expiry_date' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="number-cell-right">
                  {{element.expireDate | dateformat}}
                </mat-cell>
              </ng-container>

              <!-- Trạng thái -->
              <ng-container matColumnDef="isUsed">
                <mat-header-cell *matHeaderCellDef class="text-center">
                  {{'enterprise_branch_management.table_headers.status' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="text-center"
                          [matTooltip]="!element.isUsed? ('tooltips.not_register' | translate) : ('tooltips.registered' | translate)"
                          [ngClass]="!element.isUsed ? 'text-viettel-green' : 'text-danger'">
                  <ng-container *ngIf="!element.isUsed; else isUsed">
                    {{'form.not_register' | translate}}
                  </ng-container>
                  <ng-template #isUsed>
                    {{'form.registered' | translate}}
                  </ng-template>
                </mat-cell>
              </ng-container>

              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row">
              </mat-row>
            </mat-table>
            <!-- End table -->
          </ng-template>
        </div>

        <!--      cloud ca-->
        <div class="col-lg-3 col-sm-6 mt-3"
             *ngIf="digitalCertificate.typeCertificate == certificateType.CLOUD_CA && checkMoha != true">
          <div>
            <mat-form-field>
              <mat-label>{{'digital_certificate_management.lbl_provider_cloudca' | translate}}</mat-label>
              <mat-select #providerSelect (focusout)="(checkFocus = true)"
                          (focus)="commonService.openComboBox(checkFocus, providerSelect)" id="providerSelect"
                          [(ngModel)]="digitalCertificate.providerName"
                          (selectionChange)="checkFocus = false; onChangeSelectCertificate($event.value);"
                          #provider="ngModel"
                          name="providerSelect">
                <mat-option *ngFor="let item of lstCloudCaProvider" [value]="item.name" (click)="this.commonService.closeDropdownList(this.providerSelect)">
                  {{item.name}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="f.submitted || provider.invalid">
              <span class="text-error" *ngIf="provider?.errors?.required">
                {{'validation.provider_cloudca_required' | translate}}
              </span>
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-3 col-sm-6 mt-3"
             *ngIf="digitalCertificate.typeCertificate == certificateType.CLOUD_CA && checkMoha != true">
          <mat-form-field class="w-100">
            <input matInput type="text"
                   placeholder="{{'digital_certificate_management.lbl_account_cloudca' | translate}}"
                   (focusout)="digitalCertificate.cloudCaUsername = digitalCertificate.cloudCaUsername.trim()"
                   [(ngModel)]="digitalCertificate.cloudCaUsername" name="cloudCaUsername" #cloudCaUsername="ngModel"
                   [ngClass]="{ 'is-invalid': f.submitted && cloudCaUsername.invalid }" maxlength="200" required>
            <button mat-button *ngIf="digitalCertificate.cloudCaUsername" type="button" matSuffix mat-icon-button
                    aria-label="Clear" (click)="digitalCertificate.cloudCaUsername=''">
              <mat-icon>close</mat-icon>
            </button>
            <mat-error *ngIf="f.submitted || cloudCaUsername.invalid">
            <span class="text-error" *ngIf="cloudCaUsername?.errors?.required">
              {{'validation.account_cloudca_required' | translate}}
            </span>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-lg-6 col-sm-6 d-flex justify-content-start align-items-center"
             *ngIf="digitalCertificate.typeCertificate == certificateType.CLOUD_CA && checkMoha != true">
          <button mat-raised-button type="button"
                  [disabled]="!digitalCertificate.cloudCaUsername || !digitalCertificate.providerName "
                  (click)="getCertificateCloudCa()" color="primary">
            <mat-icon class="mr-0">list</mat-icon>
            {{'button.get_list' | translate}}
          </button>
          <button class="ml-3 primary" mat-stroked-button color="primary" type="submit" *ngIf="digitalCertificate.typeCertificate === certificateType.CLOUD_CA"
                  (click)="getQrMySign()" >
            <mat-icon class="mr-0 primary">add_circle</mat-icon>
            {{'button.Sign_up_mysign_account' | translate}}
          </button>
        </div>
        <div class="col-12 pr-075 mb-2" *ngIf="digitalCertificate.typeCertificate == certificateType.CLOUD_CA && checkMoha != true">
          <ng-container *ngIf="cloudCaDataSource == undefined; else getListSuccess"></ng-container>
          <ng-template #getListSuccess>
            <!-- Start table -->
            <mat-table [dataSource]="cloudCaDataSource" class="mt-3">
              <!-- check -->
              <ng-container matColumnDef="check">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center check-col">
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mat-header-cell-center check-col"
                          (click)="$event.stopPropagation()">
                  <mat-checkbox [disabled]="element.isUsed && element.isExtend === false" color="primary"
                                (change)="clickCertificateCA({serialNumber: element.serialNumber, activeDate: element.activeDate, expireDate: element.expireDate, checked: element.checked})"
                                [ngModelOptions]="{standalone: true}" [(ngModel)]="element.checked"></mat-checkbox>
                </mat-cell>
              </ng-container>

              <!-- Số thứ tự -->
              <ng-container matColumnDef="stt">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center no-col">
                  {{'enterprise_contract.table_headers.No' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mat-header-cell-center no-col">
                  {{element.STT}}
                </mat-cell>
              </ng-container>

              <!-- Tên chứng thư -->
              <ng-container matColumnDef="certificateName">
                <mat-header-cell *matHeaderCellDef class="text-center">
                  {{'enterprise-certificate_management.table_headers.cer_name' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" [matTooltip]="element.certificateName" class="text-center">
                  <span class="fix-width text-left">{{element.certificateName}}</span>
                </mat-cell>
              </ng-container>

              <!-- Tài khoản cloud ca -->
              <ng-container matColumnDef="cloudCaUserId">
                <mat-header-cell *matHeaderCellDef class="text-center">
                  {{'enterprise-certificate_management.table_headers.cer_name' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" [matTooltip]="element.cloudCaUserId" class="text-center">
                  <span class="fix-width text-left">{{element.cloudCaUserId}}</span>
                </mat-cell>
              </ng-container>

              <!-- serialNumber -->
              <ng-container matColumnDef="serialNumber">
                <mat-header-cell *matHeaderCellDef class="text-center">
                  {{'enterprise-certificate_management.table_headers.serial_number' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" [matTooltip]="element.serialNumber" class="text-center">
                  <span class="fix-width">{{element.serialNumber}}</span>
                </mat-cell>
              </ng-container>

              <!-- Mã số thuế -->
              <ng-container matColumnDef="taxCode">
                <mat-header-cell *matHeaderCellDef class="text-center">
                  {{'headertable.tax_code_no' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="text-center">
                  {{element.taxCode}}
                </mat-cell>
              </ng-container>

              <!-- Ngày hiệu lực -->
              <ng-container matColumnDef="activeDate">
                <mat-header-cell *matHeaderCellDef class="text-center">
                  {{'enterprise-certificate_management.table_headers.effective_date' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="number-cell-right" [ngClass]="{'text-primary': element.isExtend === true}">
                  <span *ngIf="element.isExtend === true">{{element.activeDateNew | dateformat}}</span>
                  <span *ngIf="element.isExtend === false">{{element.activeDate | dateformat}}</span>
                </mat-cell>
              </ng-container>

              <!-- Ngày hết hạn -->
              <ng-container matColumnDef="expireDate">
                <mat-header-cell *matHeaderCellDef class="text-center">
                  {{'enterprise-certificate_management.table_headers.expiry_date' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="number-cell-right" [ngClass]="{'text-primary': element.isExtend === true}">
                  <span *ngIf="element.isExtend === true">{{element.expireDateNew | dateformat}}</span>
                  <span *ngIf="element.isExtend === false">{{element.expireDate | dateformat}}</span>
                </mat-cell>
              </ng-container>

              <!-- Trạng thái -->
              <ng-container matColumnDef="isUsed">
                <mat-header-cell *matHeaderCellDef class="text-center">
                  {{'enterprise_branch_management.table_headers.status' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="text-center justify-content-center pt-2 pb-2"
                          [matTooltip]="element.statusLabel"
                          [ngClass]="element.isExtend ? 'text-primary' : !element.isUsed ? 'text-viettel-green' : 'text-danger'">
                  <ng-container>
                    <nz-tag  class="tag-status" [ngClass]="element.isExtend ? 'text-primary' : !element.isUsed ? 'text-viettel-green' : 'text-danger'">  {{element.statusLabel}}</nz-tag>

                    <mat-icon (click)="syncDataCert(element)" class="mr-0 text-primary cursor-pointer" *ngIf="element.isExtend && element.checked"
                              matTooltipClass="matTooltipBreakLine"
                              matTooltip="{{'button.synchronized_old_config' | translate}}">save_alt</mat-icon>
                  </ng-container>
                </mat-cell>
              </ng-container>

              <mat-header-row *matHeaderRowDef="displayedColumnsCloudCa"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumnsCloudCa;" matRipple class="element-row">
              </mat-row>
            </mat-table>
            <!-- End table -->
          </ng-template>
        </div>

        <div class="col-12 pr-075" *ngIf="digitalCertificate.typeCertificate == certificateType.CLOUD_CA && checkMoha != true">
          <mat-checkbox color="primary"
          [ngModelOptions]="{standalone: true}" [(ngModel)]="digitalCertificate.isSync">{{'digital_certificate_management.auto_sync_mysign' | translate}}</mat-checkbox>
        </div>
        <!--      cloud ca-->
        <!-- EASY CA -->
        <div class="col-lg-3 col-sm-6 mt-3" *ngIf="digitalCertificate.typeCertificate == certificateType.EASY_CA && checkMoha != true">
          <mat-form-field>
            <input matInput type="text"
                   placeholder="{{'digital_certificate_management.serial' | translate}}"
                   (focusout)="digitalCertificate.serial = digitalCertificate.serial.trim()"
                   [(ngModel)]="digitalCertificate.serial" name="serial" #serial="ngModel"
                   [ngClass]="{ 'is-invalid': f.submitted && serial.invalid }" maxlength="32" required>
            <button mat-button *ngIf="digitalCertificate.serial" type="button" matSuffix mat-icon-button
                    aria-label="Clear" (click)="digitalCertificate.serial=''">
              <mat-icon>close</mat-icon>
            </button>
            <mat-error *ngIf="f.submitted || serial.invalid">
            <span class="text-error" *ngIf="serial?.errors?.required">
              {{'validation.serial_required' | translate}}
            </span>
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-lg-3 col-sm-6 mt-3" *ngIf="digitalCertificate.typeCertificate == certificateType.EASY_CA && checkMoha != true">
          <mat-form-field>
            <button matSuffix mat-icon-button color="primary" type="button" (click)="showPinCode = !showPinCode">
              <mat-icon>{{!showPinCode ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
            <input [ngClass]="{ 'is-invalid': f.submitted && pin.invalid }" matInput [type]="showPinCode ? 'text' : 'password'" #focusInput [placeholder]="'digital_certificate_management.pin_code' | translate"
              name="pin" id="pin-fake" [(ngModel)]="digitalCertificate.pin"
              #pin="ngModel" required maxlength="10" autocomplete="new-password" />
            <mat-error *ngIf="f.submitted || pin?.errors?.required">
              <span class="text-error">{{'validation.pin_code_required' | translate}}</span>
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-lg-6 col-sm-6 d-flex justify-content-start align-items-center" *ngIf="digitalCertificate.typeCertificate == certificateType.EASY_CA && checkMoha != true">
          <button mat-raised-button type="button"
                  [disabled]="!digitalCertificate.serial || !digitalCertificate.pin "
                  (click)="getCertificateEasyCa()" color="primary">
            <mat-icon class="mr-0">list</mat-icon>
            {{'button.get_list' | translate}}
          </button>
        </div>

        <div class="col-12 pr-075 mb-2" *ngIf="digitalCertificate.typeCertificate == certificateType.EASY_CA && checkMoha != true">
          <ng-container *ngIf="easyCaDataSource == undefined; else getListSuccess"></ng-container>
          <ng-template #getListSuccess>
            <!-- Start table -->
            <mat-table [dataSource]="easyCaDataSource" class="mt-3">
              <!-- check -->
              <ng-container matColumnDef="check">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center check-col">
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mat-header-cell-center check-col"
                          (click)="$event.stopPropagation()">
                  <mat-checkbox [disabled]="element.isUsed && element.isExtend === false" color="primary"
                                (change)="clickCertificateEasyCA({serialNumber: element.serialNumber, activeDate: element.activeDate, expireDate: element.expireDate, checked: element.checked})"
                                [ngModelOptions]="{standalone: true}" [(ngModel)]="element.checked"></mat-checkbox>
                </mat-cell>
              </ng-container>

              <!-- Số thứ tự -->
              <ng-container matColumnDef="stt">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center no-col">
                  {{'enterprise_contract.table_headers.No' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mat-header-cell-center no-col">
                  {{element.STT}}
                </mat-cell>
              </ng-container>

              <!-- Tên chủ thể -->
              <ng-container matColumnDef="issuedTo">
                <mat-header-cell *matHeaderCellDef class="text-center">
                  {{'enterprise-certificate_management.table_headers.cer_name' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" [matTooltip]="element.issuedTo" class="text-center">
                  <span class="fix-width text-left">{{element.issuedTo}}</span>
                </mat-cell>
              </ng-container>

              <!-- serialNumber -->
              <ng-container matColumnDef="serialNumber">
                <mat-header-cell *matHeaderCellDef class="text-center">
                  {{'enterprise-certificate_management.table_headers.serial_number' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" [matTooltip]="element.serialNumber" class="text-center">
                  <span class="fix-width">{{element.serialNumber}}</span>
                </mat-cell>
              </ng-container>

              <!-- Mã số thuế -->
              <ng-container matColumnDef="taxCode">
                <mat-header-cell *matHeaderCellDef class="text-center">
                  {{'digital_certificate_management.tax_code_no' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="text-center" [matTooltip]="element.taxCode">
                  {{element.taxCode}}
                </mat-cell>
              </ng-container>

              <!-- Ngày hiệu lực -->
              <ng-container matColumnDef="activeDate">
                <mat-header-cell *matHeaderCellDef class="text-center">
                  {{'enterprise-certificate_management.table_headers.effective_date' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="number-cell-right" [ngClass]="{'text-primary': element.isExtend === true}">
                  <span *ngIf="element.isExtend === true">{{element.activeDateNew | dateformat}}</span>
                  <span *ngIf="element.isExtend === false">{{element.activeDate | dateformat}}</span>
                </mat-cell>
              </ng-container>

              <!-- Ngày hết hạn -->
              <ng-container matColumnDef="expireDate">
                <mat-header-cell *matHeaderCellDef class="text-center">
                  {{'enterprise-certificate_management.table_headers.expiry_date' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="number-cell-right" [ngClass]="{'text-primary': element.isExtend === true}">
                  <span *ngIf="element.isExtend === true">{{element.expireDateNew | dateformat}}</span>
                  <span *ngIf="element.isExtend === false">{{element.expireDate | dateformat}}</span>
                </mat-cell>
              </ng-container>

              <!-- Trạng thái -->
              <ng-container matColumnDef="isUsed">
                <mat-header-cell *matHeaderCellDef class="text-center">
                  {{'enterprise_branch_management.table_headers.status' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="text-center"
                          [matTooltip]="!element.isUsed? ('tooltips.not_register' | translate) : ('tooltips.registered' | translate)"
                          [ngClass]="!element.isUsed ? 'text-viettel-green' : 'text-danger'">
                  <div class="w-100 text-center">
                    <ng-container *ngIf="!element.isUsed; else isUsed">
                      {{'form.not_register' | translate}}
                    </ng-container>
                    <ng-template #isUsed>
                      {{'form.registered' | translate}}
                    </ng-template>
                  </div>
                </mat-cell>
              </ng-container>

              <mat-header-row *matHeaderRowDef="displayedColumnsEasyCa"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumnsEasyCa;" matRipple class="element-row">
              </mat-row>
            </mat-table>
            <!-- End table -->
          </ng-template>
        </div>

        <div class="col-12 pr-075" *ngIf="digitalCertificate.typeCertificate == certificateType.EASY_CA && checkMoha != true">
          <mat-checkbox color="primary"
          [ngModelOptions]="{standalone: true}" [(ngModel)]="digitalCertificate.isSavePin">{{'digital_certificate_management.save_pin_code' | translate}}</mat-checkbox>
        </div>
      <!-- EASY CA -->

      <!-- VNEID -->

        <div class="col-lg-3 col-sm-6 mt-3"
             *ngIf="digitalCertificate.typeCertificate == certificateType.VNEID && checkMoha != true">
          <mat-form-field class="w-100">
            <input matInput type="text"
                   placeholder="{{'digital_certificate_management.lbl_account_vneid' | translate}}"
                   (focusout)="digitalCertificate.VNeIDDataUser = digitalCertificate.VNeIDDataUser.trim()"
                   [(ngModel)]="digitalCertificate.VNeIDDataUser" name="VNeIDDataUser" #VNeIDDataUser="ngModel"
                   (keydown)="blockNonNumber($event)" (paste)="blockNonNumberPaste($event)" (input)="onNumberInput()"
                   [ngClass]="{ 'is-invalid': f.submitted && VNeIDDataUser.invalid }" maxlength="200" required>
            <button mat-button *ngIf="digitalCertificate.VNeIDDataUser" type="button" matSuffix mat-icon-button
                    aria-label="Clear" (click)="digitalCertificate.VNeIDDataUser=''">
              <mat-icon>close</mat-icon>
            </button>
            <mat-error *ngIf="f.submitted || VNeIDDataUser.invalid">
            <span class="text-error" *ngIf="VNeIDDataUser?.errors?.required">
              {{'validation.account_vneid_required' | translate}}
            </span>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-lg-6 col-sm-6 d-flex justify-content-start align-items-center"
             *ngIf="digitalCertificate.typeCertificate == certificateType.VNEID && checkMoha != true">
          <button mat-raised-button type="button"
                  [disabled]="!digitalCertificate.VNeIDDataUser || disableGetCertifcate || digitalCertificate.VNeIDDataUser.length < 12"
                  (click)="getCertificateVNEID()" color="primary">
            <mat-icon class="mr-0">list</mat-icon>
            {{'button.get_list' | translate}}
          </button>
          <button class="ml-3 primary" mat-stroked-button color="primary" type="submit" *ngIf="digitalCertificate.typeCertificate === certificateType.VNEID"
                  (click)="getQrVNeID()" >
            <mat-icon class="mr-0 primary">add_circle</mat-icon>
            {{'button.sign_up_VNeID_account' | translate}}
          </button>
        </div>
        <div class="col-12 pr-075 mb-2" *ngIf="digitalCertificate.typeCertificate == certificateType.VNEID && checkMoha != true">
          <ng-container *ngIf="VNeIDDataSource == undefined; else getListSuccess"></ng-container>
          <ng-template #getListSuccess>
            <!-- Start table -->
            <mat-table [dataSource]="VNeIDDataSource" class="mt-3">
              <!-- check -->
              <ng-container matColumnDef="check">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center check-col">
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mat-header-cell-center check-col"
                          (click)="$event.stopPropagation()">
                  <mat-checkbox [disabled]="element.isUsed && element.isExtend === false" color="primary"
                                (change)="clickCertificateVNEID({serialNumber: element.serialNumber, activeDate: element.activeDate, expireDate: element.expireDate, checked: element.checked})"
                                [ngModelOptions]="{standalone: true}" [(ngModel)]="element.checked"></mat-checkbox>
                </mat-cell>
              </ng-container>

              <!-- Số thứ tự -->
              <ng-container matColumnDef="stt">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center no-col">
                  {{'enterprise_contract.table_headers.No' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mat-header-cell-center no-col">
                  {{element.STT}}
                </mat-cell>
              </ng-container>

              <!-- Nhà cung cấp -->
              <ng-container matColumnDef="issuedBy">
                <mat-header-cell *matHeaderCellDef class="text-center">
                  {{'digital_certificate_management.lbl_provider_cloudca' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" [matTooltip]="element.issuedBy" class="text-center">
                  <span class="fix-width text-left">{{element.issuedBy}}</span>
                </mat-cell>
              </ng-container>


              <!-- Tên chứng thư -->
              <ng-container matColumnDef="certificateName">
                <mat-header-cell *matHeaderCellDef class="text-center">
                  {{'enterprise-certificate_management.table_headers.cer_name' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" [matTooltip]="element.certificateName" class="text-center">
                  <span class="fix-width text-left">{{element.certificateName}}</span>
                </mat-cell>
              </ng-container>

              <!-- serialNumber -->
              <ng-container matColumnDef="serialNumber">
                <mat-header-cell *matHeaderCellDef class="text-center">
                  {{'enterprise-certificate_management.table_headers.serial_number' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" [matTooltip]="element.serialNumber" class="text-center">
                  <span class="fix-width">{{element.serialNumber}}</span>
                </mat-cell>
              </ng-container>

              <!-- Mã số thuế -->
              <ng-container matColumnDef="taxCode">
                <mat-header-cell *matHeaderCellDef class="text-center">
                  {{'digital_certificate_management.tax_code_no' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="text-center">
                  {{element.taxCode}}
                </mat-cell>
              </ng-container>

              <!-- Ngày hiệu lực -->
              <ng-container matColumnDef="activeDate">
                <mat-header-cell *matHeaderCellDef class="text-center">
                  {{'enterprise-certificate_management.table_headers.effective_date' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="number-cell-right" [ngClass]="{'text-primary': element.isExtend === true}">
                  <span *ngIf="element.isExtend === true">{{element.activeDateNew | dateformat}}</span>
                  <span *ngIf="element.isExtend === false">{{element.activeDate | dateformat}}</span>
                </mat-cell>
              </ng-container>

              <!-- Ngày hết hạn -->
              <ng-container matColumnDef="expireDate">
                <mat-header-cell *matHeaderCellDef class="text-center">
                  {{'enterprise-certificate_management.table_headers.expiry_date' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="number-cell-right" [ngClass]="{'text-primary': element.isExtend === true}">
                  <span *ngIf="element.isExtend === true">{{element.expireDateNew | dateformat}}</span>
                  <span *ngIf="element.isExtend === false">{{element.expireDate | dateformat}}</span>
                </mat-cell>
              </ng-container>

              <!-- Trạng thái -->
              <ng-container matColumnDef="isUsed">
                <mat-header-cell *matHeaderCellDef class="text-center">
                  {{'enterprise_branch_management.table_headers.status' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="text-center justify-content-center pt-2 pb-2"
                          [matTooltip]="element.statusLabel"
                          [ngClass]="element.isExtend ? 'text-primary' : !element.isUsed ? 'text-viettel-green' : 'text-danger'">
                  <ng-container>
                    <nz-tag  class="tag-status" [ngClass]="element.isExtend ? 'text-primary' : !element.isUsed ? 'text-viettel-green' : 'text-danger'">  {{element.statusLabel}}</nz-tag>

                    <mat-icon (click)="syncDataCert(element)" class="mr-0 text-primary cursor-pointer" *ngIf="element.isExtend && element.checked"
                              matTooltipClass="matTooltipBreakLine"
                              matTooltip="{{'button.synchronized_old_config' | translate}}">save_alt</mat-icon>
                  </ng-container>
                </mat-cell>
              </ng-container>

              <mat-header-row *matHeaderRowDef="displayedColumnsVNeID"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumnsVNeID;" matRipple class="element-row">
              </mat-row>
            </mat-table>
            <!-- End table -->
          </ng-template>
        </div>
      <!-- VNEID -->
      </div>


      <!-- *******_USB-Token_******* -->
      <!-- cách tải lên-->
      <div class="row">
        <div class="col-lg-4 col-sm-6 mt-3" *ngIf="digitalCertificate.typeCertificate === 1">
          <mat-form-field class="w-100">
            <mat-label> {{'digital_certificate_management.upload_by' | translate}} </mat-label>
            <mat-select #uploadSelect (focusout)="(checkFocus = true)"
                        (focus)="commonService.openComboBox(checkFocus, uploadSelect)" id="valueSelectUpload"
                        [(ngModel)]="valueSelectUpload"
                        (selectionChange)="checkFocus = false; onChangeSelectCertificate($event.value);"
                        name="valueSelectUpload">
              <mat-option [value]="0" (click)="this.commonService.closeDropdownList(this.uploadSelect)">
                {{'digital_certificate_management.upload_cert' | translate}} </mat-option>
              <mat-option [value]="1" (click)="this.commonService.closeDropdownList(this.uploadSelect)">
                {{'digital_certificate_management.upload_usb' | translate}} </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-lg-8 col-sm-12">
          <div class="mb-2" style="top: 2rem;" *ngIf="digitalCertificate.typeCertificate == 1">
            <!-- tải lên tệp file-->
            <ng-container *ngIf="valueSelectUpload === 0 ; else uploadFromUsb">
              <button mat-stroked-button color="primary" type="button" (click)="inputUpload.click()">
                <mat-icon class="mr-0">add</mat-icon>
                {{'button.attach_file' | translate}}
              </button>
              <input type="file" #inputUpload id="file" accept="application/x-x509-ca-cert"
                     class="form-control-file vt-input-form d-none" name="file" (change)="getFile($event)"/>
              <br>
              <div class="w-100">
                <mat-label> {{'validation.lbl_validation_file_required' | translate}} </mat-label>
                <br>
                <mat-label *ngIf="fileUpload" class="row col-12">
                  <span class="fix-width" [matTooltip]="fileUpload.name">{{ fileUpload.name }}</span>
                  <span>( {{ fileUpload.size | byte }} )</span>
                </mat-label>
              </div>
            </ng-container>

            <!-- tải lên từ Usb-Token -->
            <ng-template #uploadFromUsb>
              <button mat-stroked-button color="primary" (click)="onGetCertificate()" type="button">
                <mat-icon class="mr-0">usb</mat-icon>
                {{'digital_certificate_management.upload_usb_token' | translate}}
              </button>
              <mat-error>
              <span class="text-error" *ngIf="errorStatus != null">
                <ng-container *ngIf="errorStatus != 'messages.not_initPlugin'; else errorInitPlugin">
                  {{ errorStatus | translate}}
                </ng-container>
                <ng-template #errorInitPlugin>
                  <ng-container>
                    {{ 'messages.not_initPlugin' | translate}}
                  </ng-container>
                  <br>
                  <ng-container>
                    {{ 'messages.check_input_usbtoken' | translate}}
                  </ng-container>
                  <br>
                  <ng-container>
                    {{ 'messages.check_input_software' | translate}}
                    <!-- <a target="_blank" href="{{getLinkDownload()}}">
                      <strong style="cursor: pointer;">{{ 'messages.here' | translate}} </strong>
                    </a> -->
                    <a target="_blank" href="{{getLinkDownload('WINDOWS')}}">
                      <span style="cursor: pointer;">{{ 'messages.win' |
                        translate}} </span>
                    </a>
                    <a target="_blank" href="{{getLinkDownload('MACOS')}}">
                      <span style="cursor: pointer;">{{ 'messages.mac' |
                        translate}} </span>
                    </a>
                    <a target="_blank" href="{{getLinkDownload('LINUX')}}">
                      <span style="cursor: pointer;">{{ 'messages.linux' |
                        translate}} </span>
                    </a>
                    <!-- {{ 'messages.settup_in_computer' | translate}} -->
                  </ng-container>
                  <!-- <br>
                  <ng-container>
                    {{ 'messages.download_plugin_sign_os' | translate}}
                    <a target="_blank" href="{{getLinkDownload('WINDOWS')}}">
                      <strong style="cursor: pointer;">{{ 'messages.win' |
                        translate}} </strong>
                    </a>
                    <a target="_blank" href="{{getLinkDownload('MACOS')}}">
                      <strong style="cursor: pointer;">{{ 'messages.mac' |
                        translate}} </strong>
                    </a>
                    <a target="_blank" href="{{getLinkDownload('LINUX')}}">
                      <strong style="cursor: pointer;">{{ 'messages.linux' |
                        translate}} </strong>
                    </a>

                    {{ 'messages.settup_in_computer' | translate}}
                  </ng-container> -->
                </ng-template>
              </span>
              </mat-error>
            </ng-template>
          </div>
        </div>
      </div>

      <div class="row"
           *ngIf="digitalCertificate.typeCertificate === 1 && valueSelectUpload === 1
  && !errorInitPlugin && !checkDataForDigitalCertificateDetail() || digitalCertificate.typeCertificate === 1 && valueSelectUpload === 0 && this.digitalCertificate.digitalCertificateDetail[0].issuedTo">
        <div class="col-6">
          <mat-form-field class="w-100">
            <input matInput type="text" placeholder="{{'digital_certificate_management.public_by' | translate}}"
                   [value]="digitalCertificate.digitalCertificateDetail[0].issuedBy" id="cert_Issuer" readonly>
          </mat-form-field>
        </div>
        <div class="col-6">
          <mat-form-field class="w-100">
            <input matInput type="text" placeholder="{{'digital_certificate_management.cer_subject_name' | translate}}"
                   [value]="digitalCertificate.digitalCertificateDetail[0].issuedTo" id="cert_CN" readonly>
          </mat-form-field>
        </div>
        <div class="col-6">
          <mat-form-field class="w-100">
            <input matInput type="text" placeholder="{{'digital_certificate_management.serial_number' | translate}}"
                   [value]="digitalCertificate.digitalCertificateDetail[0].serialNumber" id="cert_SNB" readonly>
          </mat-form-field>
        </div>
        <div class="col-6">
          <mat-form-field class="w-100">
            <input matInput type="text" placeholder="{{'digital_certificate_management.mst_cmnd' | translate}}"
                   [value]="digitalCertificate.digitalCertificateDetail[0].taxCode" id="taxcode" readonly>
          </mat-form-field>
        </div>
        <div class="col-6">
          <mat-form-field class="w-100">
            <input matInput type="text" placeholder="{{'digital_certificate_management.start_date' | translate}}"
                   [value]="digitalCertificate.digitalCertificateDetail[0].activeDate | date: 'dd/MM/yyyy'"
                   id="cert_ValidFrom"
                   readonly>
          </mat-form-field>
        </div>
        <div class="col-6">
          <mat-form-field class="w-100">
            <input matInput type="text" placeholder="{{'digital_certificate_management.end_date' | translate}}"
                   [value]="digitalCertificate.digitalCertificateDetail[0].expireDate | date: 'dd/MM/yyyy'"
                   id="cert_ValidTo"
                   readonly>
          </mat-form-field>
        </div>
        <div class="col-6 d-none">
          <mat-form-field class="w-100">
            <input matInput type="text" placeholder="Raw Data"
                   [value]="digitalCertificate.digitalCertificateDetail[0].certRawdata" id="cert_rawData" readonly>
          </mat-form-field>
        </div>
      </div>

      <!--    nút thêm hình ảnh-->
      <div class="row mt-3">
        <div class="col-6 pr-075">
          <div nz-upload-btn class="ant-upload">
            <div class="upload-note d-flex pb-2">
            <span
              style="margin-bottom: 0.5em; font-family: inherit; display: inline-block; color: rgba(0, 0, 0, 0.65);">{{'title.upload_image_sign' | translate}}</span>
              <small class="ml-1 mr-2"><i style="font-size: 0.8rem;">({{'title.upload_image_sign_guiding6' | translate}}
                )</i></small>
              <mat-icon matSuffix
                        matTooltip="{{'title.upload_image_sign_guiding5' | translate}}"
                        class="custom-position-for-icon-digiCert">help_outline
              </mat-icon>
            </div>
            <div class="clearfix nz-upload-clearfix row" style="margin: 0;">
              <div class="col-12 pr-075 pl-0 mb-2">
                <div class="wrap-upload">
                  <div>
                    <nz-upload [nzAccept]="'image/jpeg,image/jpg,image/png'" [nzPreview]="handlePreview"
                               class="avatar-uploader" [nzCustomRequest]="dummyRequest" nzName="avatar"
                               nzListType="picture-card"
                               [nzShowUploadList]="false" [nzBeforeUpload]="beforeUpload" (nzChange)="handleChange($event)">
                      <ng-container *ngIf="!avatarUrl">
                        <i class="upload-icon" nz-icon [nzType]="loading ? 'loading' : 'plus'"></i>
                        <div class="ant-upload-text">Upload</div>
                      </ng-container>
                      <img *ngIf="avatarUrl" [src]="sanitize(avatarUrl)" style="width: 100%"/>
                    </nz-upload>
                  </div>
                  <div *ngIf="fileImageUpload!=''&&fileImageUpload!=null"  style="text-align:right; padding-right: 1rem;">
                    <i (click)="confirmDelete()" class="fa fa-trash mb-2"
                       aria-hidden="true" matTooltip="{{'tooltips.delete' | translate}}"></i>
                  </div>
                </div>
                <nz-modal [nzVisible]="previewVisible" [nzContent]="modalContent" [nzFooter]="null"
                          (nzOnCancel)="previewVisible = false">
                  <ng-template #modalContent>
                    <img [src]="sanitize(avatarUrl)" [ngStyle]="{ width: '100%' }"/>
                  </ng-template>
                </nz-modal>
              </div>

              <!--            <div class="col-12 pr-075">-->
              <!--              <span class="nz-upload-guiding">{{'title.upload_image_sign_guiding1' |-->
              <!--                translate}}<br />{{'title.upload_image_sign_guiding2' | translate}}<br />-->
              <!--                <span *ngIf="wrongFileFormat" style="color: #f44336;">{{'messages.only_accept_png_jpg' |-->
              <!--                  translate}}</span><br />-->
              <!--                <span *ngIf="fileTooLarge" style="color: #f44336;">{{'messages.image_must_than_2m' | translate}}</span>-->
              <!--              </span>-->
              <!--            </div>-->

            </div>
            <mat-error *ngIf="wrongFileFormat">
              {{'messages.only_accept_png_jpg' | translate}}
            </mat-error>
            <mat-error *ngIf="fileTooLarge">
              {{'messages.image_must_than_2m' | translate}}
            </mat-error>
          </div>
        </div>
        <div class="col-6 pr-075">
          <mat-panel-title class="mat-panel-title border-0 m-0 p-0">
          <span class="ant-upload pb-2"
                style="margin-bottom: 0.5em; font-family: inherit; display: inline-block; color: rgba(0, 0, 0, 0.65);">{{'enterprise-certificate_management.table_headers.user_management' | translate}}</span>
          </mat-panel-title>
          <div>
            <nz-input-group [nzSuffix]="suffixUserInput">
              <input nz-input [(ngModel)]="inputUserValue"
                     (input)="onChangeUserSignSearch($event)" [nzAutocomplete]="autoUserSearching"
                     [ngModelOptions]="{ standalone: true }"
                     placeholder="{{'placeholder.name_and_email' | translate}}" id="inputUser"/>
              <nz-autocomplete #autoUserSearching>
                <nz-auto-option *ngFor="let user of filteredUserOptions"
                                (selectionChange)="autocompleteUserSelected($event, user)"
                                [nzValue]="''">{{user.name}}</nz-auto-option>
              </nz-autocomplete>
            </nz-input-group>
            <ng-template #suffixUserInput>
              <nz-spin *ngIf="nzCheckLoadingUser" nzSimple [nzIndicator]="indicatorUserInput"></nz-spin>
            </ng-template>
            <ng-template #indicatorUserInput>
              <i class="nz-icon-font" nz-icon nzType="loading" style="font-size: 24px;"></i>
            </ng-template>
          </div>
          <nz-table nzBordered [nzNoResult]="null" [nzData]="userNameArr" nzShowPagination=false
                    class="mt-2 ant-table-no-border border-top-0" [ngClass]="{'is-data': userNameArr.length > 0}">
            <tbody>
            <tr *ngFor="let username of userNameArr" class="editable-row">
              <td>{{username.name}}</td>
              <td class="text-center">
                <a class="text-center" nz-popconfirm nzPopconfirmTitle="{{'popup.confirm_delete_user' | translate}}"
                   (nzOnConfirm)="deleteCertificate(username)" [nzIcon]="iconDel"
                   nzCancelText="{{ 'button.cancel' | translate }}" nzOkText="{{ 'button.ok' | translate }}">
                  <i class="fa fa-trash" aria-hidden="true" matTooltip="{{'tooltips.delete' | translate}}"></i>
                </a>
                <ng-template #iconDel>
                  <i class="text-primary" nz-icon nzType="warning" nzTheme="outline"></i>
                </ng-template>
              </td>
            </tr>
            </tbody>
          </nz-table>
        </div>
      </div>

    </mat-dialog-content>
    <!-- Tôi đã đọc, hiểu rõ, đồng ý và cam kết tuân thủ các Điều khoản -->
    <div class="row {{valueSelectCertificateType == 0 ? 'mt-5' : 'mt-2' }}">
      <div class="col-12">
        <mat-checkbox [(ngModel)]="checkAgree" (change)="onCheck()" [ngModelOptions]="{standalone: true}" color="primary">
        <span style="font-size:14px;"> {{'form.i_have_read' | translate}} <a tabindex="0"
                                                                             routerLink="/registration-terms-information-sign"
                                                                             target="_blank"> {{'form.rule' | translate}} </a>
        </span>
        </mat-checkbox>
      </div>
      <div class="col-12" *ngIf="enableButtonSave && isShowNote && digitalCertificate && digitalCertificate.typeCertificate == certificateType.CLOUD_CA">
        <!-- Chú ý: Chứng từ số đã tồn tại trên hệ thống, khi thực hiện đăng ký lại thông tin, chứng từ số cũ sẽ cập nhật trạng thái ngừng hoạt động và không thể sử dùng cho các lần ký tiếp theo -->
        <span class="text-primary note-cert mb-2"> {{'certificate.note' | translate}}</span>
      </div>
    </div>

    <mat-divider></mat-divider>

    <!-- Huỷ bỏ & Lưu -->
    <mat-dialog-actions align="center">
      <button mat-stroked-button color="primary" class="mr-3" (click)="onNoClick()" type="button">
        <mat-icon class="mr-0">cancel</mat-icon>
        {{'button.cancel' | translate}}
      </button>
      <ng-container
        *ngIf="digitalCertificate.typeCertificate === 2 || digitalCertificate.typeCertificate ===certificateType.CLOUD_CA || digitalCertificate.typeCertificate ===certificateType.EASY_CA; else notTypeSimCA">
        <button mat-raised-button type="submit" [disabled]="!enableButtonSave || !checkAgree || f.form.invalid"
                color="primary">
          <mat-icon class="mr-0">save</mat-icon>
          {{'button.save' | translate}}
        </button>
      </ng-container>
      <ng-template #notTypeSimCA>
        <button mat-raised-button type="submit" [disabled]="!checkAgree || f.form.invalid" color="primary">
          <mat-icon class="mr-0">save</mat-icon>
          {{'button.add_signing_method' | translate}}
        </button>
      </ng-template>
    </mat-dialog-actions>

  </form>
</div>
